import StaticPageHeader from "../../Common/StaticPageHeader";
import { Link } from "react-router-dom";

const TermsConditions = () => {
  return (
    <>
      <StaticPageHeader />
      <div className="container my-3">
        <div className="my-4">
          <span className="d-flex gap-2 justify-content-start align-items-center fw-bold">
            <Link to="/">
              <img className="me-2 cursor-pointer" src="home.svg" alt="home" />
            </Link>
            &gt; <span className="ms-2">Privacy Policy </span>
          </span>
        </div>
        <div className="row">
          <div className="col-12 mb-4">
            <h2>Privacy Policy</h2>
          </div>

          <div className="col-md-12">
            <div className="card  border-0">
              <div className="">
                <h5 className="mb-2">1. General</h5>
                <p className="mb-4">
                  By accessing or using the Trex Lighting Solutions website, you
                  agree to comply with the terms outlined below. These terms
                  apply to all visitors, customers, and users of our services.
                </p>

                <h5 className="mb-2">2. Products & Services</h5>
                <p className="mb-4">
                  We strive to ensure that all product descriptions,
                  specifications, and images are accurate. However, minor
                  variations may occur due to manufacturing updates or display
                  differences.
                </p>

                <h5 className="mb-2">3. Pricing & Payments</h5>
                <p className="mb-4">
                  All prices are subject to change without prior notice. Orders
                  are confirmed only after payment verification and acceptance
                  by our team.
                </p>

                <h5 className="mb-2">4. Order Acceptance</h5>
                <p className="mb-4">
                  Trex Lighting Solutions reserves the right to accept or
                  decline any order based on product availability, technical
                  feasibility, or other business considerations.
                </p>

                <h5 className="mb-2">5. Shipping & Delivery</h5>
                <p className="mb-4">
                  Delivery timelines are estimated and may vary depending on
                  location, order size, and external factors. We are not liable
                  for delays caused by logistics providers or unforeseen
                  circumstances.
                </p>

                <h5 className="mb-2">6. Returns & Replacements</h5>
                <p className="mb-4">
                  Products can be considered for replacement in case of
                  manufacturing defects, provided the issue is reported within
                  the specified time frame after delivery. Items must be unused
                  and in original condition.
                </p>

                <h5 className="mb-2">7. Warranty</h5>
                <p className="mb-4">
                  Warranty terms vary by product category and will be shared at
                  the time of purchase. Warranty does not cover damages caused
                  by improper installation, misuse, or external factors.
                </p>

                <h5 className="mb-2">8. Intellectual Property</h5>
                <p className="mb-4">
                  All website content, including text, images, and branding,
                  belongs to Trex Lighting Solutions and may not be used without
                  permission.
                </p>

                <h5 className="mb-2">9. Limitation of Liability</h5>
                <p className="mb-4">
                  Trex Lighting Solutions shall not be held liable for indirect
                  or consequential damages arising from the use of our products
                  or services.
                </p>

                <h5 className="mb-2">10. Updates to Terms</h5>
                <p>
                  We reserve the right to update these terms at any time.
                  Continued use of the website implies acceptance of the revised
                  terms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;